import { useEffect, useState } from 'react';
import { Layout, Spin, Row, Col, Card, Typography } from 'antd';
import { ArrowLeftOutlined, ArrowRightOutlined, LoadingOutlined } from '@ant-design/icons';
import { useParams } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import axios from 'axios';
import env from '../../environment';
import _ from 'lodash';
import { useSelector, useDispatch } from 'react-redux';
import { useNavigate } from 'react-router-dom';
import { stages } from '../../store/auth/actions';
import { isMobileOnly } from 'react-device-detect';
import { types as componentsType } from '../../components/widgets/typeConstant';
import Appraisal from '../Operaciones/appraisal/AppraisalAndFormalization';
import Offers from '../Operaciones/Offers/Offers';
import Documentation from '../Operaciones/documentation/Documentation';
import LayoutProducts from '../Products/LayoutProducts';
import CondictionsLegal from '../onboarding/Pages/ViabilityAndResult/CondictionsLegal';
import AgentInformation from '../HerramientasVenta/FollowUpOperations/Components/AgentInformation';
import StagesMortgages from '../../components/widgets/Different-Widgets/stagesMortgagesWidget';
import OperationBanners from './OperationBanners';

const { Text } = Typography;

const OperationStage = ({ idIMMO }) => {
	let { operationId, stage } = useParams();
	const dispatch = useDispatch();
	const navigate = useNavigate();
	const { t } = useTranslation();

	const userMortgageId = idIMMO !== undefined ? idIMMO : operationId;
	const userToken = useSelector((state) => state.auth.token);
	const operations = useSelector((state) => state.auth.operations);
	const rol = useSelector((state) => state.auth.roles);
	const refreshDataChange = useSelector((state) => state.auth.refreshData);

	const [operationsData, setOperationsData] = useState(undefined);
	const [dataMortgage, setDataMortgage] = useState();
	const [protagorasStage, setProtagorasStage] = useState(undefined);
	const [infoAgents, setInfoAgents] = useState();
	const [showStages, setShowStages] = useState(false);
	const [docsNumber, setDocsNumber] = useState(undefined);
	const [mailboxDocs, setMailboxDocs] = useState([]);

	const [openCollapse, setOpenCollapse] = useState({
		1: stage === 'documents' || stage === 'analysis' ? true : false,
		2: stage === 'banks' || stage === 'oferts' ? true : false,
		3: stage === 'appraisal' || stage === 'formalization' ? true : false
	});

	const [dataWidgetsSmall] = useState([
		{
			id: '604a3250014edb59601d1b49sdtgrcffffff',
			dashboardId: '604a31da01701c41800e34506asdfffff',
			name: 'PERSONAL_ANALYST',
			type: 'PERSONAL_ANALYST',
			xSize: '100%',
			ySize: 'auto',
			isActive: true,
			data: { stage: 'full' },
			ttlCache: '2021-03-12 00:00:00',
			select: true
		},
		{
			id: '604a3250014edb59601d1b49cffffff',
			dashboardId: '604a31da01701c41800e3450f6ffff',
			name: 'OPERATION_STAGES',
			type: 'OPERATION_STAGES',
			xSize: isMobileOnly ? 300 : '100%',
			ySize: isMobileOnly ? 500 : 'auto',
			isActive: true,
			data: { stage: stage },
			ttlCache: '2021-03-12 00:00:00'
		}
	]);

	const componenstName = {
		OPERATION_STAGES: 'document.modatTitlteSteper',
		PERSONAL_ANALYST: 'document.personalAnalyst'
	};

	const stagesTitle = [
		{ title: 'Documentación', stage: ['documents'] },
		{ title: 'Esperando oferta', stage: ['scoring_pending'] },
		{ title: 'Oferta disponible', stage: ['scoring_done'] },
		{ title: 'Gestiones previas', stage: ['er'] },
		{ title: 'Formalización', stage: ['formalization', 'finish'] }
	];

	const showPendingPay =
		process.env.REACT_APP_BRAND !== 'office' &&
		!_.isNil(operationsData?.operationData?.mortgage?.appraisalAmount) &&
		operationsData?.operationData?.mortgage?.appraisalPaid !== true;

	const showMailbox = mailboxDocs.length > 0;

	useEffect(() => {
		if (!operationId) return;
		window.scrollTo(0, 1);
		getAgentsOperations();
	}, [operationId]);

	useEffect(() => {
		if (!operations?.length || !operationId) return;

		const currentoperation = operations.find((operation) => operation.operationId === operationId);

		if (currentoperation) {
			axios
				.get(`${env.api.url}/v1/auto-things/AutoStagesGenerator/${operationId}`, {
					headers: {
						Authorization: `Bearer ${userToken}`
					}
				})
				.then((response) => {
					if (response.data.success) {
						dispatch(stages(response.data.data.currentStage));
						getStage();
						navigate(
							`/operations/${currentoperation.operationId}/${response.data.data.currentStage}`
						);
					}
				})
				.catch((err) => {
					console.error(err);
				});
		}
	}, [operationId, operations]);

	useEffect(() => {
		if (!stage) return;
		setOpenCollapse(() => ({
			1: stage === 'documents' || stage === 'analysis',
			2: stage === 'banks' || stage === 'oferts',
			3: stage === 'appraisal' || stage === 'formalization'
		}));
		calculatePendingDocuments();
	}, [stage]);

	useEffect(() => {
		if (!userMortgageId || !userToken) return;
		refreshData();
	}, [userMortgageId, userToken, refreshDataChange]);

	useEffect(() => {
		if (operationsData?.stage !== undefined) {
			dispatch(stages(operationsData.stage));
		}
	}, [operationsData?.stage]);

	useEffect(() => {
		if (!userMortgageId) return;
		getMailboxDocuments();
	}, [userMortgageId]);

	const getStage = () => {
		axios
			.get(`${env.api.url}/sb/mortgages/protagoras-operations/get-substage/${operationId}`, {
				headers: {
					Authorization: `Bearer ${userToken}`
				}
			})
			.then((response) => {
				setProtagorasStage(response.data.data);
			})
			.catch((err) => {
				console.error(err);
			});
	};

	const refreshData = () => {
		axios
			.get(`${env.api.url}/v1/operations/${userMortgageId}`, {
				headers: { Authorization: `Bearer ${userToken}` }
			})
			.then((response) => {
				setOperationsData(response.data.data);
				setDataMortgage(response.data.data.operationData);
			})
			.catch((err) => {
				console.error(err);
			});
	};

	const getMailboxDocuments = () => {
		axios
			.get(`${env.api.url}/v1/documents/get-operation-documents/${userMortgageId}`, {
				headers: { Authorization: `Bearer ${userToken}` }
			})
			.then((response) => {
				const immutableDocs = (response.data.data || []).filter((doc) =>
					doc.tags?.includes('immutable')
				);
				setMailboxDocs(immutableDocs);
			})
			.catch((err) => {
				console.error(err);
			});
	};

	const getAgentsOperations = () => {
		axios
			.get(`${env.api.url}/v1/mortgages/agents/${operationId}`, {
				headers: { Authorization: `Bearer ${userToken}` }
			})
			.then((response) => {
				setInfoAgents(response.data.data);
			})
			.catch((err) => {
				console.error(err);
			});
	};

	const handleChangeCollapse = (key) => {
		setOpenCollapse((prevOpenCollapse) => {
			const updatedOpenCollapse = { ...prevOpenCollapse };
			updatedOpenCollapse[key] = !prevOpenCollapse[key];
			Object.keys(updatedOpenCollapse).forEach((k) => {
				if (k !== key) {
					updatedOpenCollapse[k] = false;
				}
			});
			return updatedOpenCollapse;
		});
	};

	const calculatePendingDocuments = () => {
		axios
			.get(`${env.api.url}/v1/documents/request-operation-documentation/${operationId}`, {
				headers: { Authorization: `Bearer ${userToken}` }
			})
			.then((response) => {
				const documentsData = response.data.data;
				const optionalDocs = [];
				documentsData.documents.forEach((doc) => {
					const participants = doc.participants;
					const completed = doc.completed;
					for (let participant in participants) {
						if (participants[participant] === 'optional') {
							if (completed?.[participant] === false) {
								optionalDocs.push(doc);
								break;
							}
						}
					}
				});
				if (stage === 'documents') {
					setDocsNumber(documentsData.documentsNeeded - documentsData.documentsCompleted);
				} else {
					setDocsNumber(optionalDocs.length);
				}
			})
			.catch((err) => {
				console.error(err);
			});
	};

	const commonVariables = {
		stages: stage,
		analyst: operationsData?.agent,
		dataMortgage: dataMortgage,
		userMortgageId: userMortgageId,
		openCollapse: openCollapse,
		setOpenCollapse: setOpenCollapse,
		handleChangeCollapse: handleChangeCollapse,
		docsNumber: docsNumber,
		setDocsNumber: setDocsNumber
	};

	const components = {
		basic: <Documentation name={operationsData?.name} {...commonVariables} />, //<BasicStage />,
		documents: <Documentation name={operationsData?.name} {...commonVariables} />,
		analysis: <Documentation name={operationsData?.name} {...commonVariables} />,
		banks: <Documentation name={operationsData?.name} {...commonVariables} />,
		oferts: <Offers {...commonVariables} />,
		appraisal: <Appraisal {...commonVariables} />,
		formalization: <Appraisal {...commonVariables} />
	};

	if (!dataMortgage || !protagorasStage)
		return <Spin indicator={<LoadingOutlined style={{ fontSize: 50 }} spin />} className="spin" />;

	if (rol !== 'realestate') {
		return (
			<>
				<Layout
					style={{
						padding: isMobileOnly ? 16 : '0px 40px',
						height: '100%',
						marginBottom: 200,
						backgroundColor: '#F5F5F5'
					}}>
					{stage !== 'basic' && <LayoutProducts name={operationsData && operationsData.name} />}
					<Row gutter={24}>
						{isMobileOnly && (
							<>
								{!showStages ? (
									<Col span={24}>
										<div style={{ position: 'relative' }}>
											<OperationBanners
												showPendingPay={showPendingPay}
												showMailbox={showMailbox}
												mailboxDocs={mailboxDocs}
												refreshData={refreshData}
												refreshMailboxDocs={getMailboxDocuments}
												operationsData={operationsData}
												userMortgageId={userMortgageId}
											/>
										</div>
										<div
											className="card-stages-mobile"
											onClick={() => setShowStages(true)}
											style={{ marginTop: showPendingPay || showMailbox ? 32 : 0 }}>
											<Text style={{ fontSize: 16, fontWeight: 400, color: '#212121' }}>
												{t('b2bOperationList.stage')}:{' '}
												<span style={{ fontWeight: 600, marginLeft: 4 }}>
													{stagesTitle.find((s) =>
														s.stage.includes(protagorasStage?.protagorasStage)
													)?.title || ''}
												</span>
											</Text>
											<ArrowRightOutlined style={{ fontSize: 22 }} />
										</div>
									</Col>
								) : (
									<>
										<div
											onClick={() => setShowStages(false)}
											style={{
												display: 'flex',
												alignItems: 'center',
												gap: 12,
												marginLeft: 16
											}}>
											<ArrowLeftOutlined style={{ fontSize: 22 }} />
											<Text style={{ fontSize: 16, fontWeight: 700, color: '#212121' }}>
												{t('document.modatTitlteSteper')}
											</Text>
										</div>
										<div className="card-stages-mobile-open">
											<StagesMortgages protagorasStage={protagorasStage} />
										</div>
									</>
								)}
							</>
						)}

						{!showStages && (
							<Col
								span={isMobileOnly ? 24 : 18}
								style={{
									marginBottom: isMobileOnly ? 16 : 24,
									marginTop: isMobileOnly ? 8 : 0
								}}>
								<div style={{ position: 'relative' }}>
									{!isMobileOnly && (
										<OperationBanners
											showPendingPay={showPendingPay}
											showMailbox={showMailbox}
											mailboxDocs={mailboxDocs}
											refreshData={refreshData}
											refreshMailboxDocs={getMailboxDocuments}
											operationsData={operationsData}
											userMortgageId={userMortgageId}
										/>
									)}
									{components[stage]}
								</div>
							</Col>
						)}
						<Col span={isMobileOnly ? 24 : 6}>
							{!isMobileOnly ? (
								dataWidgetsSmall &&
								dataWidgetsSmall.map((box) => {
									const ComponentsType = componentsType[box.type];
									const nameData = componenstName[box.name];
									return (
										<Card
											style={{
												minWidth: box.type === 'PERSONAL_ANALYST' ? 243 : box.xSize,
												height: box.ySize,
												marginBottom: '24px',
												borderRadius: 4
											}}
											key={box.id}>
											<Layout
												style={{
													display: 'contents',
													backgroundColor: 'white'
												}}>
												<Text
													strong
													style={{
														fontSize: '16px',
														color: '#212121',
														display: 'flex',
														placeContent: 'center'
													}}>
													{box.type !== 'PERSONAL_ANALYST' && box.type !== 'OPERATION_STAGES'
														? t(`${nameData}`)
														: ''}
												</Text>
												<div>
													<ComponentsType
														data={box}
														analyst={operationsData?.agent}
														mortgageId={operationId}
														managementCode={operationsData?.managementCode}
														stage={operationsData?.stage}
														protagorasStage={protagorasStage}
													/>
												</div>
											</Layout>
										</Card>
									);
								})
							) : (
								<AgentInformation
									image={_.get(infoAgents, 'analyst.avatar.link', '')}
									name={_.get(infoAgents, 'analyst.name', '')}
									managementCode={operationsData?.managementCode}
									valuesDataAgent={operationsData}
									infoAgents={infoAgents}
								/>
							)}
						</Col>
						{stage === 'oferts' && !showStages && (
							<div
								style={{
									fontSize: 10,
									fontWeight: 400,
									color: '#424242',
									padding: isMobileOnly && 16,
									marginTop: isMobileOnly && -20
								}}>
								<CondictionsLegal></CondictionsLegal>
							</div>
						)}
					</Row>
				</Layout>
			</>
		);
	}
};

export default OperationStage;
